import React from 'react';
import ModuleImagePage from '../shared/ModuleImagePage.jsx';

const Receivables = () => <ModuleImagePage moduleKey="receivables" />;

export default Receivables;
